const routes = [{
  path: '/document',
  component: () => import('@/views/document'),
  name: 'document',
  meta: {
    title: '文档管理',
    desc: '规章制度、管理规范等文件的线上管理模块'
  }
}]

export default routes



// WEBPACK FOOTER //
// ./src/router/setting/document.js